export default __webpack_public_path__ + "static/media/sparck-mountain-waves-orange.9198e14c.png";